import { AppDate } from '../envTypes';

import { ModelBase } from './base';

export type VisibilityType = 'all' | 'allSeller' | 'allBuyer' | 'deferred';

export interface SlackContact {
  slackMemberId: string;
  slackName?: string;
  zendeskOwnerId?: number;
}

export interface InventoryFilter {
  filter: string;
  createdAt: AppDate;
}

export interface StripeAccountLink {
  url: string;
  expiredAt: AppDate;
}

export enum XPopPlatform {
  Psl = 'psl',
  Popstore = 'popstore',
}

// see https://animate.style/.
export enum AnimationStyle {
  None = 'none',
  Bounce = 'bounce',
  Flash = 'flash',
  Pulse = 'pulse',
  RubberBand = 'rubberBand',
  ShakeX = 'shakeX',
  ShakeY = 'shakeY',
  HeadShake = 'headShake',
  Swing = 'swing',
  Tada = 'tada',
  Wobble = 'wobble',
  Jello = 'jello',
  HeartBeat = 'heartBeat',
}

export enum RecaptchaAction {
  GuestAccountCreation = 'guest_account_creation',
  LeadFormSubmission = 'lead_form_submission',
  LeadContactCreation = 'lead_contact_creation',
}

/**
 * Use to calculate the sale tax for pop.store order
 */
export interface PaymentBillingAddress {
  firstName?: string;
  lastName?: string;
  line1: string;
  line2?: string;
  city: string;
  state: string;
  country: string;
  postalCode: string;
}

export type EditorialTextFormat = 'html' | 'text' | 'markdown';

export type DeepPartial<T> = {
  [P in keyof T]?: T[P] extends object ? DeepPartial<T[P]> : T[P];
};

export interface PausedBy {
  userId: string;
  role: 'host' | 'admin';
}

// imported from: https://assets.avalara.com/taxcodes/global/prod/Avalara_goods_and_services.xlsx?date=2023-07-05
// see: https://taxcode.avatax.avalara.com/
export interface TaxCode extends ModelBase {
  taxCode: string;
  description?: string;
  extraDescription?: string;
}

export enum AccountApplicationEmailType {
  QUESTION = 'question',
  DATA_DELETION = 'data_deletion',
  DATA_RETRIEVAL = 'data_retrieval',
}

export enum ReportReasonEnum {
  Spam = 'spam',
  Inappropriate = 'inappropriate',
  Aggressive = 'aggressive',
}

export type ReportReason = 'spam' | 'inappropriate' | 'aggressive';
